import { BookOpen, Cpu, GraduationCap, type LucideIcon } from "lucide-react";

/**
 * Every guide the site has, in reading order. The list page renders this, the front page's
 * "Where next" points at it, and a new guide is one entry plus its route.
 */
export interface Guide {
  /** The route. The tutorial is the front page. */
  to: string;
  title: string;
  /** One sentence: who it is for and what they leave with. */
  text: string;
  icon: LucideIcon;
  /** Reading time, when it is a tutorial rather than a reference. */
  minutes?: number;
}

export const GUIDES: Guide[] = [
  {
    to: "/",
    title: "Getting started",
    text: "Set up, drive the maze by hand, write an agent, take the baseline apart, understand the score. Where everyone starts.",
    icon: GraduationCap,
    minutes: 45,
  },
  {
    to: "/guidelines/local",
    title: "On your own machine",
    text: "The simulator in your own process: practice on any maze without spending attempts, see the truth while you debug, and an experimental reinforcement learning demo.",
    icon: Cpu,
    minutes: 20,
  },
  {
    to: "/sdk",
    title: "SDK reference",
    text: "connect(), Session, the REST client and every option, for using the SDK without the kit.",
    icon: BookOpen,
  },
];

/** The guides other than the one at `current`, for a "where next" strip. */
export function otherGuides(current: string): Guide[] {
  return GUIDES.filter((g) => g.to !== current);
}
